import NewsletterForm from '../NewsletterForm';

function NewsletterSection() {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 relative overflow-hidden border border-gray-100">
          <div className="absolute top-0 right-0 w-40 h-40 bg-[#73BDF2] rounded-full opacity-10 transform translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#73BDF2] rounded-full opacity-10 transform -translate-x-1/2 translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-16 h-16 bg-[#73BDF2] rounded-full opacity-10 transform translate-x-1/3 translate-y-1/3"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <p className="eyebrow mb-3">Stay in the Loop</p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold mb-4">
                Stay Updated with Exclusive Travel Services & Offers!
              </h2>
              <p className="text-gray-600">
                Subscribe to our newsletter to receive the latest updates
                about our travel tips and service updates.
              </p>
            </div>
            <div className="md:w-1/2 md:pl-8 w-full">
              <NewsletterForm />
              <p className="text-sm text-gray-500 mt-4">
                By subscribing, you agree to our Privacy Policy and Terms of
                Service.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsletterSection;
